import { useEffect, useState } from 'react';
import { css } from '@emotion/react'

import { DateTime } from 'luxon';

import styled from '@emotion/styled'
import EditForm from '../../utils/utilities/EditForm';

import { fields, initialValues, schema, additionalState, parseData } from './config';

import ShoppingCartCheckoutRoundedIcon from '@mui/icons-material/ShoppingCartCheckoutRounded';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';

import Sidebar from './Components/Sidebar';

import { UrlParamsContext } from '../../contexts/UrlParams';

import { useParams } from 'react-router-dom';

import { nanoid } from 'nanoid';


const EditInvoice = () => {

  const { id } = useParams();

  const [isEdit, setIsEdit] = useState(id ? true : false);

  const [initValues, setInitValues] = useState({...initialValues, date: DateTime.now(), due_date: DateTime.now(), checkout_id: nanoid(8)});

  const [formFields, setFormFields] = useState([...fields.map(field => ({...field}))]);

   const additionalButtons = !isEdit ? [
    { text: "Save Invoice", variant: "outlined", color: "primary", icon: <ShoppingCartCheckoutRoundedIcon />, forceClose: true, redirect: `/invoices`},
    { text: "Continue to Payment", variant: "contained", color: "primary", icon: <ArrowForwardRoundedIcon />, redirect: null, redirect_to_edit: true}
  ] : [{ text: "Save Invoice", variant: "contained", color: "primary", icon: <ShoppingCartCheckoutRoundedIcon />, forceClose: true, redirect: `/invoices`}]
  
  return (
    <UrlParamsContext.Provider value={{isEdit, setIsEdit}}>
      <EditForm title={"Invoice"} initialValues={initValues} fields={formFields} schema={schema} url={"invoices"} 
      sidebar={<Sidebar />} 
      parseData={parseData}
      dialog={true} // to avoid navigation
      additionalState={additionalState} collection_id="invoice_id" additionalButtons={additionalButtons} submitButton={true} invalidate_queries={[["appointments"]]}>
      </EditForm>
    </UrlParamsContext.Provider>
  );
}

export default EditInvoice;